// ============================================================================
// SUBJECT METADATA
// ============================================================================

export const SUBJ = {
  english: { icon: '📖', label: 'English', color: '#0369A1', bg: '#E0F2FE' },
  economics: { icon: '📊', label: 'Economics', color: '#7C3AED', bg: '#EDE9FE' },
  accounting: { icon: '💰', label: 'Accounting', color: '#0F766E', bg: '#CCFBF1' },
  biology: { icon: '🔬', label: 'Biology', color: '#065F46', bg: '#DCFCE7' },
  chemistry: { icon: '⚗️', label: 'Chemistry', color: '#9A3412', bg: '#FEE2E2' },
  mathematics: { icon: '📐', label: 'Mathematics', color: '#1D4ED8', bg: '#DBEAFE' },
  physics: { icon: '⚡', label: 'Physics', color: '#B45309', bg: '#FEF3C7' },
  government: { icon: '🏛️', label: 'Government', color: '#3F6212', bg: '#F7FEE7' },
  literature: { icon: '📚', label: 'Literature', color: '#831843', bg: '#FCE7F3' },
  novel: { icon: '📗', label: 'The Lekki Headmaster', color: '#831843', bg: '#FCE7F3' },
};
